<template>
     <div id="Tariff" style="float: right;width:100%;height: 100%;direction:rtl">
        <div class="card" style="float: right;width:100%;height: 100%">
            <div class="card-header">
                <CRow>
                     <h3 class="card-title"  > <CIcon name="cil-map" style="width: 20px;height: 20px"/>&nbsp;&nbsp;
                        تعرفه خط
                    </h3>
                </CRow>
               
                 <CRow>
                    <CCol>
                        
                        <CSelect label="انتخاب خط" ref="fleetSelect"   :options="GetOtions($store.state.Fleets.RequestResponse)" :value.sync="FleetID"   @change="changeFleet" > </CSelect>
                    </CCol>
                    <CCol>
                        
                    </CCol>
                    <CCol>
                        
                    </CCol>
                    <CCol>
                        <CButton v-if="FleetID!==0" @click="ShowDialogAddOrUpdate"   color="outline-primary" style="float:left;border-bottom-left-radius: 2px;border-top-left-radius: 2px;border-top-right-radius: 2px;border-bottom-right-radius: 2px" title="افزودن" >افزودن</CButton>&nbsp;
                    </CCol>
                    <!-- @change="indexPriority=$event.target.selectedIndex" -->

                </CRow>
            
            </div>
            <div class="card-body" style="float: right;width:100%;height: 100%;min-height: 450px">
                    <CDataTable
                        :hover="true"
                        :border="true"
                        
                        :striped="true"
                        :small="true"
                        :items="$store.state.SmartTariff_GetAll.RequestResponse"
                        :fields="fields"
                        :fixed="true"
                        :loading="false"
                        :items-per-page="10"
                        pagination
                    :noItemsView="{ noResults: 'چیزی یافت نشد.', noItems: 'چیزی برای نمایش وجود ندارد.' }"
            >
                
            <template #Rows="{index}">
                <td >
                    {{index+1}}
                </td>
            </template>
            <template #DevicePercent="{item}">
                <td >
                    {{GetDeviceNumber(item)}}
                </td>
            </template>
            <template #Edit="{item}">
                <td style="font-size: 16px">
                    <CButton   color="primary" @click="Edit(item)" >ویرایش</CButton>
                </td>
            </template>
            <template #Delete="{item}">
                <td>
                    <CButton  color="danger"  @click="SmartTariff_Delete(item)" >
                        حذف
                    </CButton>
                </td>
            </template>
            </CDataTable>
            </div>
            <div class="card-footer" style="direction:ltr;display: flex;gap:10px" v-if="$store.state.SmartTariff_GetAll.RequestResponse.length>0">
                <MPrint v-if="$store.state.SmartTariff_GetAll.length>0" :data="$store.state.SmartTariff_GetAll.RequestResponse" label="PDF" title="تعرفه خط" :fields="fields"></MPrint>
            </div>
        </div>
        <CModal
                title=""
                color="info"
                :closeOnBackdrop="false"
                :size="'sm'"
                :show.sync="DialogAddOrUpdate"
        >
            <div style="direction: ltr;text-align: right">
                
                    
                <CRow>
                    
                    <CCol>
                        <CSelect label="انتخاب خط" disabled   :options="GetOtions($store.state.Fleets.RequestResponse)" :value.sync="FleetID"      style="color: white" > </CSelect>
                    </CCol>
                    <CCol>
                        <CSelect label="انتخاب روز"   :options="GetOtionsDay($store.state.DayDefine_GetAll.RequestResponse)" :value.sync="DayDefineID"  @change="changeDay"    style="color: white" > </CSelect>
                    </CCol>
                </CRow>
                
                <CRow style="direction:rtl">
                    <CCol>
                        <CInput style="width:100%;max-width:300px;" type="number" v-model="txtNumberDevice" disabled  label="تعداد کل"/>
                    </CCol>
                    <CCol>
                        <CInput style="width:100%;max-width:300px;" type="number" v-model="txtPercent" @change="ChangePercent()" :isValid="IsValidPercent()" label="درصد"/>
                    </CCol>
                    
                </CRow>
                <CRow style="direction:rtl">
                    <CCol>
                        <CInput style="width:100%;max-width:300px;" type="number" v-model="txtPercentNumberDevice" disabled  label="ظرفیت بر اساس درصد"/>
                    </CCol>
                    <CCol>
                        <CInput style="width:100%;max-width:300px;" type="number" @change="ChangeTotalTime()" v-model="txtTotalTime" label="زمان کلی"/>
                    </CCol>
                    
                </CRow>
                <CRow style="direction:rtl">
                    <CCol>
                        <CInput style="width:100%;max-width:300px;" type="number" v-model="txtItemTimeMin" disabled :isValid="IsValidItemTime()"  label="حداقل سر فاصله"/>
                    </CCol>
                    <CCol>
                        <CInput style="width:100%;max-width:300px;" type="number" v-model="txtItemTime" @change="ChangeTime" :isValid="IsValidItemTime()"  label="سر فاصله"/>
                        <!-- <CInput style="width:100%;max-width:300px;" type="number" v-model="txtTotalTime" label="زمان کلی"/> -->
                    </CCol>
                    
                </CRow>
                <CRow style="direction:rtl">
                    <CCol>
                        <CInput style="width:100%;max-width:300px;" type="number" v-model="txtItemPause" disabled :isValid="IsValidItemTime()"  label="زمان توقف"/>
                    </CCol>
                    <CCol>
                        
                        <!-- <CInput style="width:100%;max-width:300px;" type="number" v-model="txtTotalTime" label="زمان کلی"/> -->
                    </CCol>
                    
                </CRow>
                
                
        
                
            </div>
            <template #header>

                <h4 class="modal-title" style="direction: rtl"> <CIcon name="cil-sun" width="20px" height="20px"/>&nbsp;&nbsp; تعرفه خط </h4>

            </template>
            <template #footer>
                <CButton @click="DialogAddOrUpdate = false" color="danger">انصراف</CButton>
                <CButton @click="SmartTariff_InsertAndUpdate()" color="primary">&nbsp;&nbsp;ذخیره</CButton>
            </template>
        </CModal>
    </div>
</template>
<script>
export default {
    data(){
        return{
            DialogAddOrUpdate:false,
            fields:[{key:"Rows","label":"ردیف"},{key:"FleetName","label":"عنوان خط"},{key:"Name","label":"عنوان روز"},{key:"Percent","label":"ظرفیت(درصد)"},{key:"DeviceNumber","label":"تعداد کل"},{key:"DevicePercent","label":"تعداد"},{key:"DistanceTime","label":"سر فاصله"},{key:"Edit","label":"ویرایش"},{key:"Delete","label":"حذف"}],
            indexFleet:0,
            indexFleet2:0,
            indexDay:0,
            txtNumberDevice:'0',
            txtPercentNumberDevice:'0',
            txtPercent:'80',
            txtTotalTime:'60',
            txtItemTimeMin:'15',
            txtItemTime:'0',
            txtItemPause:'0',
            FleetID:0,
            DayDefineID:0,
        }
    },
    computed:{
        ReadSmartTariff_InsertAndUpdate(){
            return this.$store.state.SmartTariff_InsertAndUpdate;
        },
        ReadSmartTariff_Delete(){
            return this.$store.state.SmartTariff_Delete;
        },
    },
    watch:{
        ReadSmartTariff_InsertAndUpdate(res){
            if(res.Status!==undefined){
                if(res.Status){
                    if(res.RequestResponse[0].Message==='Successfully!'){
                        this.DialogAddOrUpdate=false;
                        this.SmartTariff_GetByFleetID(this.FleetID);
                        this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'})
                    }
                    
                }
            }
        },
        ReadSmartTariff_Delete(res){
            if(res.Status!==undefined){
                if(res.Status){
                    if(res.RequestResponse[0].Message==='Successfully!'){
                        if(this.indexFleet==0){
                            this.SmartTariff_GetAll();
                        }
                        else{
                            this.SmartTariff_GetByFleetID(this.$store.state.Fleets.RequestResponse[this.indexFleet-1].FleetID);
                        } 
                        this.$store.commit('ShowToast',{type:'success',message:'عملیات با موفقیت انجام شد.'})
                    }
                    
                }
            }
        },
    },
    mounted(){
        this.GetFleets();
        this.DayDefine_GetAll();
    },
    methods:{
        changeFleet(data){
            this.indexFleet=data.target.selectedIndex;
            this.SmartTariff_GetByFleetID(this.FleetID);          
        },
        changeDay(data){
            this.indexDay=data.target.selectedIndex;
                      
        },
    
        GetFleets(){
            this.$store.commit('FleetByUser');
        },
        SmartTariff_GetAll(){
            this.$store.commit('SmartTariff_GetAll');
        },
        SmartTariff_GetByFleetID(fleetID){
            this.$store.commit('SmartTariff_GetByFleetID',{
                FleetID:fleetID
            });
        },
        SmartTariff_Delete(item){
            this.$store.commit('SmartTariff_Delete',{
                FleetID:item.FleetID,
                DayDefineID:item.DayDefineID,
            });
        },
        SmartTariff_InsertAndUpdate(){
            if(this.DayDefineID!==0){
                this.$store.commit('SmartTariff_InsertAndUpdate',{
                    FleetID:this.FleetID,
                    DayDefineID:this.DayDefineID,
                    Percent:this.txtPercent,
                    TotalTime:this.txtTotalTime,
                    DistanceTime:this.txtItemTime,
                });
            }
            else{
                this.$store.commit('ShowToast',{type:'error',message:'لطفا روز را انتخاب نمایید'})
            }
        },
        DayDefine_GetAll(){
            this.$store.commit('DayDefine_GetAll');
            
        },
        GetOtions(fleets){
                var options=[];
                var all={value:-1,label:'-- انتخاب کنید --',disabled:true};
                options.push(all);
                for(var i=0;i<fleets.length;i++){
                    var fleet=fleets[i];
                    var option={value:fleet.FleetID,label:fleet.FleetName};
                    options.push(option);
                }
                return options;
        },
        GetOtionsDay(items){
                var options=[];
                var all={value:0,label:'-- انتخاب کنید --',disabled:true};
                options.push(all);
                for(var i=0;i<items.length;i++){
                    var item=items[i];
                    var option={value:item.DayDefineID,label:item.Name};
                    options.push(option);
                }
                return options;
        },
        IsValidPercent(){
            if(parseInt(this.txtPercent)<0 ){
                this.txtPercent=0;
            }
            else if( parseInt(this.txtPercent)>100){
                this.txtPercent=100;
            }
            
            return true;
        },
        IsValidItemTime(){
            var NumberDevice=this.$store.state.Fleets.RequestResponse[this.indexFleet2].NumberDevice
            var nd=Math.floor(parseInt(this.txtTotalTime)/(Math.floor(NumberDevice*parseInt(this.txtPercent)+1)/100))+1
            if(nd>parseInt(this.txtItemTime)){
                this.txtItemTime=nd;
            }
            
            return true
        },
        ShowDialogAddOrUpdate(){
            this.DayDefineID=0;
            this.DialogAddOrUpdate=true;
            this.txtNumberDevice=this.$store.state.Fleets.RequestResponse[this.indexFleet2].NumberDevice;
            this.ChangePercent();
        },
        ChangePercent(){
            var NumberDevice=this.$store.state.Fleets.RequestResponse[this.indexFleet2].NumberDevice
            console.log(NumberDevice)
            var nd=Math.floor(NumberDevice*parseInt(this.txtPercent)/100)+1;
            this.txtPercentNumberDevice=nd;
            if(parseInt(this.txtPercentNumberDevice)>NumberDevice){
                this.txtPercentNumberDevice=NumberDevice;
            }
            
            var nd2=Math.floor(parseInt(this.txtTotalTime)/(Math.floor(NumberDevice*parseInt(this.txtPercent)+1)/100))+1
            this.txtItemTimeMin=nd2;
            this.txtItemTime=nd2;
            this.txtItemPause=parseInt(this.txtItemTime)-parseInt(this.txtItemTimeMin)
        },
        ChangeTime(){
            this.txtItemPause=parseInt(this.txtItemTime)-parseInt(this.txtItemTimeMin)
        },
        Edit(item){
            this.FleetID=item.FleetID;
            this.DayDefineID=item.DayDefineID;
            this.txtNumberDevice=item.DeviceNumber;
            this.txtPercent=item.Percent;
            this.DialogAddOrUpdate=true;
            this.indexFleet2=this.GetIndexFleet(item.FleetID)
            this.ChangePercent();
            this.txtItemTime=item.DistanceTime;
        },
        GetIndexFleet(fleetID){
            var index=-1;
            for(var i=0;i<this.$store.state.Fleets.RequestResponse.length;i++){
                if(this.$store.state.Fleets.RequestResponse[i].FleetID===fleetID){
                    index=i;
                    break;
                }
            }
            return index;
        },
        ChangeTotalTime(){
            this.ChangePercent();
            this.txtItemPause=parseInt(this.txtItemTime)-parseInt(this.txtItemTimeMin)
        },
        GetDeviceNumber(item){
            var ret=Math.floor(item.DeviceNumber*parseInt(item.Percent)/100)+1
            if(item.DeviceNumber<ret){
                ret=item.DeviceNumber;
            }
            return ret;
        }
    }
}
</script>